import React, {useEffect, useState} from "react";
import { useIntl } from "react-intl";
import Page from "../../../components/general/page";
import AliquoteDetailPage from "../../../components/report/vatSettlements/aliquoteDetail";

const AliquoteDetailView = props => {
  const { pageRef } = props;
  const [subtitle, setSubtitle] = useState("Riepilogo");
  const intl = useIntl();
  
  useEffect(()=>{
    const hrefValues = window.location.href.split("/");
    let iva = hrefValues[hrefValues.length - 1].replace("IVA","");
    if (iva) {
      setSubtitle(intl.formatMessage({ id: "reports.vat.activityDetail.detail" }) + " " +
        intl.formatMessage({ id: "reports.vat.activityDetail.rateExemption" }).toLowerCase() + " " +
        iva + "%");
    }
  },[]);

  return (
    <Page
      pageRef={pageRef}
      title={"Liquidazione IVA"}
      backUrl={"/reports/vat"}    
      subtitle={subtitle}
    >
      <AliquoteDetailPage/>
    </Page>
  );
};

export default AliquoteDetailView;
